
import './displayMessage.css'
function Texts({name}) {
  return (
    <div className='testbox' >
        <p> Welcome to {name}'s app</p>
        <p> We are currently under construction</p>
      
    </div>
  );
}

export default Texts;
